// Define the function outside so it is globally accessible for onclick attributes
/*function handleMobileEvent(el) {
    const $modal = $(el).siblings('.event-modal');
    $modal.addClass('active');
    $('#overlay').addClass('active');
}

$(document).ready(function() {
    // Handle closing the modal when clicking the overlay
    $('#overlay').on('click', function() {
        $('.event-modal').removeClass('active');
        $(this).removeClass('active');
    });

    // Close modal when clicking close button
    $(".modal-close").click(function() {
        $(".event-modal").removeClass("active");
        $('#overlay').removeClass('active');
    });
});
*/




